import React from 'react';
import CustomModal from './CustomModal';

const SourceModal = ({ isSourceModalOpen, closeModal, sourceInput, handleSourceInputChange, handleSourceSubmit, isLoading }) => {
  return (
    <CustomModal
      isOpen={isSourceModalOpen}
      onRequestClose={closeModal}
      overlayClassName="react-modal-overlay"
      modalClassName="modal-base-class react-source-modal-content"
    >
      <h2 className="modal-title">Extract from URL</h2>
      <p className="modal-description">Paste a URL to generate Known Good Answers (KGAM)</p>
      <div className="modal-input-container">
        <input type="text" value={sourceInput} onChange={handleSourceInputChange} />
      </div>
      <button className="modal-submit-button" onClick={handleSourceSubmit}>Submit</button>
      {isLoading && <div>Loading...</div>}
    </CustomModal>
  );
};

export default SourceModal;
